module.exports = __webpack_public_path__ + "images/dec8e201febacebe37ee5d81ad59c3c3.svg";